import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'lib-list-view-mobile-filters',
  templateUrl: './list-view-mobile-filters.component.html',
})
export class ListViewMobileFiltersComponent {
  @Input() areMobileFiltersOpen: boolean;
  @Input() filters: any;
  @Input() filtersForm: UntypedFormGroup;
  @Output() cancelFiltersClicked: EventEmitter<null> = new EventEmitter();
  @Output() applyFiltersClicked: EventEmitter<null> = new EventEmitter();
  @Output() clearFiltersClicked: EventEmitter<null> = new EventEmitter();
  @Output() formCreated: EventEmitter<null> = new EventEmitter();
  @Output() typeAheadOptionSelected: EventEmitter<any> = new EventEmitter();

  applyFilters() {
    this.applyFiltersClicked.emit();
  }

  clearFilters() {
    this.clearFiltersClicked.emit();
  }

  cancelMobileFiltersOpen() {
    this.cancelFiltersClicked.emit();
    this.areMobileFiltersOpen = false;
  }
}
